import { waybillImport } from '@/api/index'

// export function getIntervalNoAll (data, params) {
//   const extendUrl = params.urlParam ? '?' + params.urlParam : ''
//   return waybillImport.request({
//     method: 'post',
//     url: '/GetintervalNoAll' + extendUrl,
//     data
//   })
// }

// export function waybillImportDecryptColumn (data) {
//   return waybillImport.request({
//     method: 'post',
//     url: '/PubilcDataDecryptColumn',
//     data
//   })
// }

export function importData (data) {
  return waybillImport.request({
    method: 'post',
    url: '/ImportData',
    data,
    iSFromData: true
  })
}

export function Getdrflag (data) {
  return waybillImport.request({
    method: 'post',
    url: '/Getdrflag',
    data
  })
}
